import {remCalc} from '_themeUtils'

const footerLegal = {
    FooterLegal: {
        baseStyle: () => ({
            legalContainer: {
                gap: {base: 'spacing.2', md: 0},
                direction: {base: 'column', lg: 'row'},
                align: {base: 'center', md: 'flex-start', lg: 'center'},
                textAlign: {base: 'center', md: 'left'},
                w: 'full',
            },
            copyrightText: {
                textStyle: {base: 'paragraphSm', md: 'paragraphMd'},
                fontWeight: 400,
                color: 'color.border.grey.600',
                flex: 1,
                display: 'inline',
            },
            copyrightImage: {
                w: remCalc(20),
                h: remCalc(20),
                display: 'inline',
                verticalAlign: 'middle',
            },
            copyrightLink: {
                _hover: {
                    underline: 'none',
                    color: 'color.text.black',
                },
            },
        }),
    },
}

export default footerLegal
